import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { hideLoader, showLoader } from '../../../api/loader/loaderSlice';
import { apiClient } from '../../../utils/axios';
import { AxiosError } from 'axios';

export const fetchComplianceData = async ({ queryKey }) => {
  const [, params] = queryKey;
  const { data } = await apiClient.get(`/dashboard/compliance`, { params });
  return data;
};

export const useGetComplianceDataHandler = ({ startDate, endDate }) => {
  const dispatch = useDispatch();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['compliance_data', { startDate, endDate }],
    queryFn: async (context) => {
      dispatch(showLoader());
      try {
        return await fetchComplianceData(context);
      } finally {
        dispatch(hideLoader());
      }
    },
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
    retry: 3,
  });

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        dispatch(
          showSnackbar({
            message: error.response?.data?.message || error.message,
            severity: 'error',
          }),
        );
      } else {
        dispatch(
          showSnackbar({
            message: JSON.stringify(error),
            severity: 'error',
          }),
        );
      }
    }
  }, [dispatch, error, isError]);

  return {
    complianceData: data,
    isLoading,
  };
};
